import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import PageIntro from "@/components/feature/PageIntro";
import MissionSection from "../home/components/MissionSection";
import CtaSection from "../home/components/CtaSection";
import { Link } from "react-router-dom";
export default function AboutPage() {
  return (
    <>
      <Navbar />
      <main id="main-content">
        <PageIntro
          eyebrow="About Harambee"
          title="Pulling together for shared prosperity."
        >
          <p>
            We are building a bridge between African ambition and the people,
            knowledge, and relationships that can help it grow.
          </p>
        </PageIntro>
        <section className="section-space">
          <div className="shell purpose-grid">
            <div>
              <p className="eyebrow">Who we are</p>
              <h2>
                African roots.
                <br />A collective future.
              </h2>
            </div>
            <div>
              <p className="large-copy">
                Harambee means “pulling together” in Swahili. That spirit shapes
                our approach to development.
              </p>
              <p className="body-copy">
                Harambee Global Ventures is an international subsidiary of 7
                Hills Development Group LLC. We are developing an education,
                enterprise, and advisory platform that connects communities on
                the continent with the global African diaspora.
              </p>
              <p className="body-copy">
                Nairobi is our intended East African anchor, with connections
                through Fort Lauderdale, Florida. Our work is at an early stage:
                we welcome conversations with learners, entrepreneurs, families,
                and potential partners as we develop our programs.
              </p>
              <Link className="text-link" to="/leadership">
                Meet our leadership <span aria-hidden="true">↗</span>
              </Link>
            </div>
          </div>
        </section>
        <MissionSection />
        <section className="section-space">
          <div className="shell">
            <p className="eyebrow">What guides us</p>
            <h2>Our commitments.</h2>
            <div className="pillar-grid">
              {[
                {
                  title: "Local ownership",
                  text: "Listen to local priorities and develop collaborations with the people closest to the opportunities and challenges.",
                },
                {
                  title: "Clear expectations",
                  text: "Be transparent about what is available, what is in development, and what we can responsibly commit to.",
                },
                {
                  title: "Lasting capability",
                  text: "Build knowledge, relationships, and practical skills that support long-term economic participation.",
                },
              ].map((v) => (
                <div className="pillar-card" key={v.title}>
                  <h3>{v.title}</h3>
                  <p>{v.text}</p>
                </div>
              ))}
            </div>
          </div>
        </section>
        <CtaSection />
      </main>
      <Footer />
    </>
  );
}
